export default "__VITE_ASSET__Czp6TE_6__"